module.exports = __webpack_public_path__ + "img/beer_id-65.b3f5cf15.png";